import React from 'react';

import { HomePage } from './components/HomePage';

export function HomeNavigation() {
	return <HomePage />;
}
